import { DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Checkbox,
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tooltip,
  Tr,
  Wrap,
  Text,
  IconButton,
} from "@chakra-ui/react";
import TableLoader from "components/common/TableLoader/TableLoader";
import CustomInput from "components/common/customInput/CustomInput";
import { FieldArray } from "formik";
import { FaPlus } from "react-icons/fa";
import {
  notificationsApprovals,
  notificationsType,
  notificationtIsActive,
  sortIsActive,
  triggerApprovals,
} from "../utils/constant";

const NotificationTable = ({
  activePage,
  values,
  setFieldValue,
  isDisabled,
  generateLevels,
}: any) => {
  const handleChange = (index: number, selectedOptions: any) => {
    const newApprovalArray = selectedOptions.map((option: any) => option.value);
    setFieldValue(`notification[${index}].approval`, newApprovalArray);
  };

  const handleTypeChange = (
    index: number,
    type: string,
    isChecked: boolean
  ) => {
    const currentTypes = values.notification[index].type || [];
    const newTypes = isChecked
      ? [...currentTypes, type]
      : currentTypes.filter((t: string) => t !== type);
    setFieldValue(`notification[${index}].type`, newTypes);
  };

  return (
    <Box display={activePage === 2 ? "block" : "none"} p={4}>
      <Flex alignItems="center" gap={3}>
        <Text mt={2} fontWeight="500" whiteSpace="nowrap">
          Update First Level User Always:
        </Text>
        <CustomInput
          disabled={isDisabled}
          type="switch"
          value={values.updateFirstUserNotification}
          name="updateFirstUserNotification"
          onChange={(e: any) =>
            setFieldValue(`updateFirstUserNotification`, e.target.checked)
          }
        />
      </Flex>

      <Flex justifyContent="flex-end" mb={4}>
        {values?.notification.length === 0 && (
          <Tooltip label="Add Notification" hasArrow placement="left">
            <Button
              onClick={() => {
                setFieldValue("notification", [
                  ...values.notification,
                  {
                    approval: triggerApprovals,
                    level: "Level 1",
                    isActive: sortIsActive[0],
                    type: [],
                  },
                ]);
              }}
              bg="teal.400"
              color="white"
              _hover={{ bg: "teal.500" }}
              isDisabled={isDisabled}
              leftIcon={<FaPlus />}
            >
              Add Notification
            </Button>
          </Tooltip>
        )}
      </Flex>
      <Text mt={3} fontWeight="500">
        Define Notification
      </Text>
      <Box overflowY="auto">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Approvals</Th>
              <Th>Level</Th>
              <Th display="none">Is Active</Th>
              <Th>Type</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <FieldArray name="notification">
            {({ remove }) => (
              <TableLoader show={values?.notification.length} loader={false}>
                <Tbody>
                  {values.notification.map((notification: any, index: any) => (
                    <Tr key={index}>
                      <Td p={3}>
                        <CustomInput
                          type="select"
                          name={`notification[${index}].approval`}
                          value={notification.approval}
                          placeholder="Select Approval"
                          options={notificationsApprovals}
                          onChange={(e: any) =>
                            setFieldValue(`notification[${index}].approval`, e)
                          }
                          rest={{ minWidth: "220px" }}
                          disabled={isDisabled}
                          isBoxSelect
                          isMulti
                        />
                      </Td>
                      <Td p={3} w={{ base: "320px", lg: "360px" }}>
                        <CustomInput
                          type="select"
                          name={`notification[${index}].level`}
                          value={notification.level}
                          options={generateLevels(values.levels)}
                          placeholder="Select Level"
                          onChange={(e: any) =>
                            setFieldValue(`notification[${index}].level`, e)
                          }
                          rest={{ minWidth: "220px" }}
                          disabled={isDisabled}
                          isBoxSelect
                          isMulti
                        />
                      </Td>
                      <Td p={3} display="none">
                        <CustomInput
                          type="select"
                          name={`notification[${index}].isActive`}
                          value={notification.isActive}
                          placeholder="Select"
                          options={notificationtIsActive}
                          onChange={(e: any) =>
                            setFieldValue(`notification[${index}].isActive`, e)
                          }
                          rest={{ minWidth: "220px" }}
                          disabled={isDisabled}
                          isBoxSelect
                        />
                      </Td>
                      <Td p={3} w={{ base: "320px", lg: "unset" }}>
                        <Wrap spacing={4} align="center">
                          {notificationsType.map((type) => (
                            <Checkbox
                              key={type.value}
                              colorScheme="teal"
                              size="sm"
                              isChecked={notification.type.includes(type.value)}
                              onChange={(e) =>
                                handleTypeChange(
                                  index,
                                  type.value,
                                  e.target.checked
                                )
                              }
                              isDisabled={isDisabled}
                            >
                              {type.label}
                            </Checkbox>
                          ))}
                        </Wrap>
                      </Td>

                      <Td p={3}>
                        <Flex>
                          <Tooltip
                            label="Delete Notification"
                            hasArrow
                            placement="left"
                          >
                            <IconButton
                              type="button"
                              colorScheme="red"
                              size={'sm'}
                              variant="outline"
                              onClick={() => remove(index)}
                              isDisabled={isDisabled}
                              aria-label="Delete Notification"
                              mr={3}
                              icon={<DeleteIcon />}
                            />
                          </Tooltip>

                          {index === values?.notification.length - 1 && (
                            <Tooltip
                              label="Add Notification"
                              hasArrow
                              placement="left"
                            >
                              <IconButton
                                bg="teal.400"
                                color="white"
                                size={'sm'}
                                _hover={{ bg: "teal.500" }}
                                onClick={() => {
                                  setFieldValue("notification", [
                                    ...values.notification,
                                    {
                                      approval: triggerApprovals,
                                      level: "Level 1",
                                      isActive: sortIsActive[0],
                                      type: ["email", "notification"], // Example default types
                                    },
                                  ]);
                                }}
                                isDisabled={isDisabled}
                                icon={<FaPlus />}
                                aria-label="Add Notification"
                              />
                            </Tooltip>
                          )}
                        </Flex>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </TableLoader>
            )}
          </FieldArray>
        </Table>
      </Box>
    </Box>
  );
};

export default NotificationTable;
